import React from 'react';
import { assertNever } from '../../../utils/helpers';

import { museum } from '../../../data';
import { ROutroRemotePersonalTranscriptDemo } from './r-outro-remote-personal-demo';
import { ROutroRemotePersonalTranscriptBrighton } from './r-outro-remote-personal-brighton';
import { ROutroRemotePersonalTranscriptMunch } from './r-outro-remote-personal-munch';
import { ROutroRemotePersonalTranscriptCop26 } from './r-outro-remote-personal-cop26';


const Transcript = (museum.slug === 'demo') ? ROutroRemotePersonalTranscriptDemo
                 : (museum.slug === 'brighton') ? ROutroRemotePersonalTranscriptBrighton
                 : (museum.slug === 'munch') ? ROutroRemotePersonalTranscriptMunch
                 : (museum.slug === 'mpu') ? ROutroRemotePersonalTranscriptDemo
                 : (museum.slug === 'cop-26') ? ROutroRemotePersonalTranscriptCop26
                 : assertNever(museum.slug);


const ROutroRemotePersonalTranscript: React.FC = () => {
  return <Transcript />;
};

export {
  ROutroRemotePersonalTranscript,
};
